module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADwAAAAtCAYAAADydghMAAAAAXNSR0IArs4c6QAAAOFJREFUaAXtmkEKwjAQRRsVPEnO0ZXex3MoeCBXPUdO4kLjfOzAgFDcJnmBZpqki7yXttBpponSt4HkeLXWfSnlYu2THUfvbzw+bf6PnPM9pfQSy8GBBGvQVxt4W9x5f8txZTkbmzBuqiLY3BOs4LRwYrLTWW2VCLyEC76jjddhARdHGe4ZdnAiBjCAAQxgAAMYwAAGMICBTQPDfS2R8eglvaP7OiQ0yHjIxhBZy803GoMYwAAGMIABDGAAAxjAAAbcABmP8NfcpTQbVxb2ePgKssfDTTQcf/ZpNczC1P8y8AGro6fg5jDLRwAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./static/list.png
// module id = 3XYh
// module chunks = 0